import React, {FC, useEffect, useMemo, useState} from 'react'
import {useDispatch} from 'react-redux'
import {messageTypes, SendMessage, useStickersGreeting} from 'entities/messages'
import {mediaVariants} from 'shared/lib'
import {Button} from 'shared/ui/buttons'
import {ChatUpgradeAccount} from '../chatUpgradeAccount'
import styles from './styles.module.scss'

const welcomeMessages = [
  'Hi! 👋',
  'I like your photos 💖',
  'Could you make me smile 🥺',
  'How are you today? 🙂',
  'Perfect date for you? 👩‍❤️‍👨',
  'Lets talk? 💬',
  'Do we have a chance? 🙏',
  'What is your hobby? 🤗',
  'Do you come here often? 👩‍💻',
  'Do you believe in destiny? 🤔',
]

export const ChatStartDialog: FC<{idUser: string}> = ({idUser}) => {
  const dispatch = useDispatch()
  const [text, setText] = useState('')
  const {refetch} = SendMessage(idUser, {text}, messageTypes.text, dispatch)
  const stickersGreeting = useStickersGreeting()
  const randomGreetingSticker = useMemo(
    () => stickersGreeting[Math.floor(Math.random() * stickersGreeting.length)],
    [stickersGreeting.length]
  )
  const {refetch: sendSticker} = SendMessage(idUser, {id: randomGreetingSticker?.id || 0}, messageTypes.sticker, dispatch)

  useEffect(() => {
    if (!text) return

    refetch().then(() => setText('')).catch(console.error)
  }, [text])

  return (
    <div className={styles.notMessages}>
      <div className={styles.giftAndSticker}>
        <div className={styles.item}>
          <img src={randomGreetingSticker?.data.url + mediaVariants.square256} alt='stiker' className={styles.sticker} />
          Start with a sticker
          <Button styleType='primary' fullwidth onClick={() => sendSticker().catch(console.error)}>Send</Button>
        </div>
      </div>
      <div className={styles.messages}>
        {welcomeMessages.map((item, index) => <div className={styles.item} onClick={() => setText(item)} key={index}>
          {item}
        </div>)}
      </div>
      <ChatUpgradeAccount />
    </div>
  )
}